import { render } from "./AccordionItemWithEdit.vue?vue&type=template&id=799b0122"
import script from "./AccordionItemWithEdit.vue?vue&type=script&lang=js"
export * from "./AccordionItemWithEdit.vue?vue&type=script&lang=js"

import "./AccordionItemWithEdit.vue?vue&type=style&index=0&id=799b0122&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__